import React from "react";

const ProfileIcon = ({ url }) => {
  return (
    <img src={url} alt="logo" className="object-contain h-8 w-8 rounded-2xl" />
  );
};

export default ProfileIcon;